import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/wallets', // Though unused as read only...

    defaults : {
      id : "",
      current_balance : "",
      withdrawable_amount : "",
      reference_type : "",
      reference_id : "",
      transactions: "",
      created : "",
      modified : "",
      deleted : ""
    },
    
    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true
      },
      "user" : {
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "mediator" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "garage-staff" : {
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "manager" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "booking-manager" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      }
    }

});
